// TODO: Remove suggestions when the search box is empty.
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["searchInput"]

  initialize() {
    this.listeners = {
      removeSuggestions: this.removeSuggestions.bind(this),
    }
  }

  connect () {
    document.addEventListener("click", this.listeners.removeSuggestions)
  }

  disconnect () {
    document.removeEventListener("click", this.listeners.removeSuggestions)
  }


  removeSuggestions(event) {
    // If we clicked inside the suggestion UI, do nothing.
    if (this.element.contains(event.target)) { return }
    // If we clicked an element that is no longer part of the document, do nothing. This happens if the target is a suggestion that has just been clicked on and thus removed from the DOM.
    if (!document.contains(event.target)) { return }

    const suggestionContainer = document.querySelector("#playlist-video-suggestions")
    suggestionContainer.innerHTML = ""
    suggestionContainer.src = null

    this.searchInputTarget.value = ""
  }
}
